export function getPrevIndex(current, arr) {
  return (current + arr.length - 1) % arr.length;
}

export function getNextIndex(current, arr) {
  return (current + 1) % arr.length;
}
